import React from "react";
import CustomInput from "../../../../../../../Components/CustomInputs/CustomInput";
import { updateFirstStepGeneralFields } from "../../../../../../../redux/reducers/claimReducer";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const InjuryBodyPartInjuredPreviouslyDescriptionField: React.FC = () => {
   const fieldNameLowerCase = "injuryBodyPartInjuredPreviouslyDescription";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);
   const dispatch = useDispatch();

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase[fieldNameLowerCase]
   );

   const dependencyValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase
            .injuryBodyPartInjuredPreviously
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);
   return (
      <WholeLineContainer
         dependencyValue={
            shouldRenderSpecField(
               "GeneralFields",
               fieldNameUpperCase,
               visibilityMatrixes
            ) && dependencyValue
         }
      >
         <CustomInput
            labelText="Jakým způsobem?"
            placeholderText="Uveďte, o jaké šlo poranění"
            value={fieldValue || ""}
            onChange={(e) => {
               dispatch(
                  updateFirstStepGeneralFields({
                     value: e.target.value,
                     field: fieldNameLowerCase,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               fieldNameUpperCase,
               claimFieldErrorsMessages
            )}
            maxCharacters="100"
            inputRef={ref}
         />
      </WholeLineContainer>
   );
};

export default InjuryBodyPartInjuredPreviouslyDescriptionField;
